<span class="caption">Edit panel</span>
<div *ngIf="(isReadOnly$ | async) !== true" class="buttons-container">
  <h3-split-view-auto-ground-button></h3-split-view-auto-ground-button>
  <h3-split-view-rescale-toggle
    *ngIf="!isSingleFrameTask"
  ></h3-split-view-rescale-toggle>
  @if (!isNewEditPanel) {
    <h3-toggle-edit-panel-button></h3-toggle-edit-panel-button>
  }
</div>
